import { render, staticRenderFns } from "./framework-topbar.vue?vue&type=template&id=1448d57a&"
import script from "./framework-topbar.vue?vue&type=script&lang=js&"
export * from "./framework-topbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports